import * as types from "_graphql-types/graphql";
import { UserFlagCheck } from "./Authorized";

// Single source of truth for who may reach the Organization settings surface
// (#4889): super users OR org admins (DCAdmin). Imported by BOTH the /organization
// route gate (mercury_app) and the navbar menu entry, so they can't drift and
// leave DCAdmins able to deep-link but with no menu item (or vice-versa).
export const ORG_MANAGEMENT_CHECKS: UserFlagCheck[] = ["isSuperUser", "DCAdmin"];

export function isAuthorized({
  user,
  checks,
}: {
  user: types.CurrentUserQuery["currentUser"];
  checks: UserFlagCheck[];
}): boolean {
  return checks.some(check => {
    return !!user.flags[check];
  });
}
